import { OptaStat } from '../types/responseTypes';

export function getOptaItemValue(item: OptaStat, key: string): number {
  const optaValue = item && item.Stat && Array.isArray(item.Stat)
    && item.Stat.find((value) => value['@attributes'].name === key);
  return optaValue ? parseFloat(optaValue['@value']) : 0;
}
